import { Routes } from "@angular/router";
import { AuthGuard } from "../guards/auth.guard";
import { GlobalAdminAccessGuard } from "../guards/global_admin_access.guard";
import { MerchantsAccessGuard } from "../guards/merchants_access.guard";
import { SwitchAccountAccessGuard } from "../guards/switch_account_access.guard";

export const CommonLayout_ROUTES: Routes = [
    {
        path: "dashboard",
        loadChildren: () =>
            import("../../dashboard/dashboard.module").then((m) => m.DashboardModule),
        canMatch: [AuthGuard],
    },
    {
        path: "add-assessment",
        loadChildren: () =>
            import("../../add_assessment/add_assessment.module").then((m) => m.AddAssessmentModule),
        canMatch: [AuthGuard]
    },
    {
        path: "saq_form",
        loadChildren: () =>
            import("../../saq_form/saq_form.module").then((m) => m.SaqFormModule),
        canMatch: [AuthGuard],
    },
    {
        path: "roc_form",
        loadChildren: () =>
            import("../../roc_form/roc_form.module").then((m) => m.RocFormModule),
        canMatch: [AuthGuard],
    },
    {
        path: "admin-console",
        loadChildren: () =>
            import("../../admin_console/admin_console.module").then((m) => m.AdminConsoleModule),
        canMatch: [AuthGuard, SwitchAccountAccessGuard],
    },
    {
        path: "switch-account",
        loadChildren: () =>
            import("../../admin/switch_account/switch_account.module").then((m) => m.SwitchAccountModule),
        canMatch: [AuthGuard, SwitchAccountAccessGuard],
    },
    {
        path: "merchants",
        loadChildren: () =>
            import("../../merchants/merchants.module").then((m) => m.MerchantsModule),
        canMatch: [AuthGuard, MerchantsAccessGuard],
    },
    {
        path: "coming-soon",
        loadChildren: () =>
            import("../components/coming_soon/coming_soon.module").then((m) => m.ComingSoonModule),
        canMatch: [AuthGuard],
    },
    {
        path: "user-settings",
        loadChildren: () =>
            import("../components/user_settings/user_settings.module").then((m) => m.UserSettingsModule),
        canMatch: [AuthGuard],
    },
    {
        path: "organization-settings",
        loadChildren: () =>
            import("../components/org_settings/org_settings.module").then((m) => m.OrgSettingsModule),
        canMatch: [AuthGuard, GlobalAdminAccessGuard],
    },
    {
        path: "support",
        loadChildren: () =>
            import("../components/support/support.module").then((m) => m.SupportModule),
        canMatch: [AuthGuard],
    },
    {
        path: "release-notes",
        loadChildren: () =>
            import("../components/release_notes/release_notes.module").then((m) => m.ReleaseNotesModule),
        canMatch: [AuthGuard]
    },
    {
        path: "secure-storage",
        loadChildren: () =>
            import("../../secure_storage/secure_storage.module").then((m) => m.SecureStorageModule),
        canMatch: [AuthGuard]
    }
];
